import * as React from 'react';
import { classes, style } from 'typestyle';
import { Black, Blue, White } from '../../../styles/colors';
const ListItem = (props) => {
    const { leftCell, centerCell, rightCell, active, selected, small, className = '', onClick, disabled, hideLeftCell = false, } = props;
    const classNames = [
        className,
        active ? classes('active', listItemActiveStyle) : '',
        selected ? classes('selected', listItemSelectedStyle) : '',
        small ? classes('small', listItemStyle.small) : listItemStyle.normal,
        disabled && disabledStyles.item,
    ];
    const disabledCell = disabled && disabledStyles.cell;
    return (React.createElement("div", { className: classes(`ta-list-item`, ...classNames), onClick: onClick },
        !hideLeftCell && (React.createElement("div", { className: classes('ta-left-cell', cellStyle, leftCellStyle) }, leftCell && (React.createElement("div", { className: classes(disabledCell, small ? leftCellContentStyle.small : leftCellContentStyle.normal) }, leftCell)))),
        React.createElement("div", { className: classes('ta-center-cell', cellStyle, centerCellStyle) },
            React.createElement("div", { className: classes(disabledCell, small ? centerCellContentStyle.small : centerCellContentStyle.normal) }, centerCell)),
        React.createElement("div", { className: classes('ta-right-cell', cellStyle, rightCellStyle) }, rightCell && (React.createElement("div", { className: classes(disabledCell, small ? rightCellContentStyle.small : rightCellContentStyle.normal) }, rightCell)))));
};
export default ListItem;
// CSS patterns
const beLikeIconCss = {
    width: 24,
    minWidth: 24,
    height: 24,
};
// Styles
const listItemStyleCommon = {
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    cursor: 'pointer',
    boxSizing: 'border-box',
    color: Black,
    $nest: {
        '& .tds-list-item-text': {
            wordBreak: 'break-word',
        },
    },
};
const listItemStyle = {
    normal: style(Object.assign(Object.assign({}, listItemStyleCommon), { minHeight: 48 })),
    small: style(Object.assign(Object.assign({}, listItemStyleCommon), { minHeight: 40 })),
};
const cellStyle = style({
    display: 'flex',
});
const leftCellStyle = style({
    justifyContent: 'flex-start',
    minWidth: 44,
    boxSizing: 'border-box',
});
const leftCellContentCommons = Object.assign({ boxSizing: 'content-box' }, beLikeIconCss);
const leftCellContentStyle = {
    small: style(Object.assign(Object.assign({}, leftCellContentCommons), { padding: '8px 8px 8px 12px' })),
    normal: style(Object.assign(Object.assign({}, leftCellContentCommons), { padding: '12px 8px 12px 12px' })),
};
const centerCellStyle = style({
    justifyContent: 'center',
    flexDirection: 'column',
    flexGrow: 1,
    width: 0,
    wordBreak: 'break-all',
});
const rightCellStyle = style({
    minWidth: 12,
    flexShrink: 0,
});
const centerCellContentStyle = {
    normal: style({
        padding: '8px 0',
    }),
    small: style({
        padding: '4px 0',
    }),
};
const rightCellCommon = Object.assign({ boxSizing: 'content-box' }, beLikeIconCss);
const rightCellContentStyle = {
    normal: style(Object.assign(Object.assign({}, rightCellCommon), { padding: '12px 12px 12px 8px' })),
    small: style(Object.assign(Object.assign({}, rightCellCommon), { padding: '8px' })),
};
const listItemSelectedStyle = style({
    $nest: {
        '& .tds-list-item-text-title': {
            color: `${Blue}`,
            fontWeight: 'bold',
        },
    },
});
const listItemActiveStyle = style({
    backgroundColor: Blue,
    borderColor: `${Blue}`,
    $nest: {
        '& .ta-left-cell, & .ta-center-cell, & .ta-right-cell': {
            boxShadow: `0 -1px ${Blue} inset !important`,
        },
        '& .tds-list-item-text-title, & .tds-list-item-text-description': {
            color: `${White}`,
        },
    },
});
const disabledStyles = {
    cell: style({ $nest: { '&': { opacity: 0.5 }, '.tds-list-item-text-description': { color: Black } } }),
    item: style({ pointerEvents: 'none' }),
};
//# sourceMappingURL=ListItem.js.map